import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CAMPAIGN_STATUS } from '@app/constant/CampaignConstant'
import { InertiaLink } from '@inertiajs/inertia-react'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function CampaignIndex({ campaigns }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('CAMPAIGNS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'merchants_count',
              Header: t('CAMPAIGNS.TOTAL_MERCHANTS'),
              accessor: 'merchants_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'vouchers_count',
              Header: t('CAMPAIGNS.TOTAL_VOUCHERS'),
              accessor: 'vouchers_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'total_cost',
              Header: t('CAMPAIGNS.TOTAL_PRICE'),
              accessor: 'total_cost',
              type: 'number',
              disableFilters: true,
            },
            {
              id: 'total_points',
              Header: t('CAMPAIGNS.TOTAL_POINTS'),
              accessor: 'total_points',
              type: 'number',
              disableFilters: true,
            },
            {
              id: 'codes_count',
              Header: t('CAMPAIGNS.TOTAL_CODES'),
              accessor: 'codes_count',
              type: 'number',
              disableFilters: true,
            },
            {
              id: 'remain_time',
              Header: t('CAMPAIGNS.REMAIN_TIME'),
              accessor: ({ start_at, end_at }) => ({ start_at, end_at }),
              type: 'remainingTime',
              disableFilters: true,
              disableSortBy: true,
            },
            {
              id: 'status',
              Header: t('CAMPAIGNS.STATUS'),
              accessor: ({ status }) => t(`CAMPAIGNS.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: CAMPAIGN_STATUS.ACTIVE, name: t('CAMPAIGNS.ACTIVE') },
                { value: CAMPAIGN_STATUS.IN_ACTIVE, name: t('CAMPAIGNS.INACTIVE') },
                { value: CAMPAIGN_STATUS.REJECTED, name: t('CAMPAIGNS.REJECTED') },
              ],
            },
            {
              id: 'action',
              Header: t('CAMPAIGNS.ACTIONS'),
              disableFilters: true,
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('partner.campaigns.show', row.original.id)}>
                  <PageviewIcon />
                </IconButton>
              ),
            },
          ]}
          data={campaigns}
          routeName="partner.campaigns.index"
        />
      </Grid>
    </Grid>
  )
}
